import {
  getQueryWithParams,
  getQuery,
  postMutation,
} from "src/components/ApolloConnection/ApolloProviderComponent";
import {
  GET_DOCTOR_SCHEDULES,
  GET_DOCTOR_ID,
  LIST_APPOINTMENTS_SCHEDULE,
} from "src/components/graphql/GraphQLquery";
import { snackbar } from "@mobiscroll/react5";
import {
  REMOVE_SCHEDULE,
  REMOVE_SCHEDULE_GROUP,
  ADD_SCHEDULE,
} from "src/components/graphql/GraphQLmutation";

export async function getSchedules(start, end) {
  try {
    const doctorId = sessionStorage["role-id"];
    if (doctorId !== null) {
      const data = {
        doctorId,
        start,
        end,
      };
      let response = await getQueryWithParams(GET_DOCTOR_SCHEDULES, data);
      
      if (!response || response.errors) {
        throw new Error(response?.errors?.[0]?.message || "Failed to fetch schedules");
      }

      const result = response?.data?.listSchedules;
      
      // Check for error response (statusCode >= 400)
      if (result?.statusCode && result.statusCode >= 400) {
        throw new Error(result?.message || "Failed to fetch schedules");
      }
      
      // Success case
      return result?.data || [];
    } else {
      return [];
    }
  } catch (error) {
    snackbar({
      message: error.message,
      color: "danger",
    });
    console.error("Error at getSchedules:", error);
    return [];
  }
}

export async function getData(start, end) {
  const response = await getSchedules(start, end);
  let data = [];
  if (response) {
    response.forEach((_el) => {
      const { duration, end, gap, id, doctorId, recurrence, start, relatedId } =
        _el;
      let el = {
        duration,
        end,
        gap,
        id,
        doctorId,
        recurrence,
        relatedId,
        start,
      };
      data.push(el);
    });
  }
  return data;
}

export async function addSchedule(data) {
  try {
    const response = await postMutation(ADD_SCHEDULE, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to add schedule");
    }

    const result = response?.data?.addSchedule;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to add schedule");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Schedule added successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at addSchedule:", e);
    return false;
  }
}

export function storeSchedules(data) { }

export async function getDoctorId() {
  try {
    let response = await getQuery(GET_DOCTOR_ID);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch doctor ID");
    }

    const result = response?.data?.getMyProfile;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch doctor ID");
    }
    
    // Success case
    if (result?.data) {
      return result.data.id;
    }
    throw new Error("No doctor ID returned");
  } catch (error) {
    console.error("Error at getDoctorId:", error);
    return null;
  }
}

export async function removeSchedule(data) {
  try {
    let response = await postMutation(REMOVE_SCHEDULE, data);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to remove schedule");
    }

    const result = response?.data?.removeSchedule;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to remove schedule");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Schedule removed successfully.",
      color: "success",
    });
    return response;
  } catch (error) {
    snackbar({
      message: error.message,
      color: "danger",
    });
    console.error("Error at removeSchedule:", error);
    return undefined;
  }
}

export async function removeScheduleGroup(data) {
  try {
    let response = await postMutation(REMOVE_SCHEDULE_GROUP, data);
    
    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to remove recurring schedule");
    }

    const result = response?.data?.removeScheduleGroup;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to remove recurring schedule");
    }
    
    // Success case
    snackbar({
      message: result?.message || "Recurring schedule removed successfully.",
      color: "success",
    });
    return true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at removeScheduleGroup:", e);
    return null;
  }
}

export async function listAppointments(filters, start) {
  try {
    const response = await getQuery(LIST_APPOINTMENTS_SCHEDULE(filters, start));

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch appointments");
    }

    const result = response?.data?.listAppointmentsDoctor;
    
    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch appointments");
    }
    
    // Success case
    if (result?.data) {
      console.log("List of Appointments fetched successfully.");
      return result.data;
    }
    return [];
  } catch (e) {
    console.error("Error at listAppointments:", e);
    return [];
  }
}
